import styles from '../Login.module.css';
import React, { useEffect, useState } from "react";
import { TextField, Button, CircularProgress } from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import { changeNewUserPassword } from "../../../api/apiCall";
import { useForm } from "react-hook-form";
import paceLogo from '../../../assets//paceLogo.jpg';
import { toast } from 'react-toastify';

type FormValues = {
    newPassword: string
    confirmPassword: string
}

const ChangePassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { token } = location.state || {};
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, formState: {errors}, setError } = useForm<FormValues>();

    const userLogin = async (data: any) => {
        if (data.newPassword !== data.confirmPassword) {
            setError("confirmPassword", {
                type: "manual",
                message: "Passwords do not match",
            });
            return;
        }

        setLoading(true);
        const response: any = await changeNewUserPassword(token, data.confirmPassword);

        if(response?.status === 200) {
            navigate('/');
        } else {
            toast.error("Something went wrong!")
        }
        setLoading(false);
    };

    useEffect(() => {
        if (!token) {
            navigate("/", { replace: true });
        }
    }, [token, navigate]);

    return (
        <div className={styles.container}>
            <div className={styles.loginForm}>
                <form className={styles.formLogin} onSubmit={handleSubmit(userLogin)}>
                    <img src={paceLogo} style={{ width: "150px", height: "auto" }} alt={"pace-logo"} />
                    <h2>Welcome to PACE</h2>
                    <p style={{marginTop: -10}}>Set your new password to continue</p>
                    <TextField
                        label="New Password"
                        type="password"
                        color="warning"
                        {...register("newPassword", {
                            required: true,
                            minLength: {
                                value: 6,
                                message: "Password must be at least 6 characters",
                            },
                        })}
                        error={!!errors.newPassword}
                        helperText={errors.newPassword?.message}
                        style={{margin: '15px', width: '350px', backgroundColor: 'white'}}
                    />
                    <TextField
                        label="Confirm Password"
                        type="password"
                        color="warning"
                        {...register("confirmPassword", {
                            required: true,
                            minLength: {
                                value: 6,
                                message: "Password must be at least 6 characters",
                            },
                        })}
                        error={!!errors.confirmPassword}
                        helperText={errors.confirmPassword?.message}
                        style={{margin: '15px', width: '350px', backgroundColor: 'white'}}
                    />
                    <Button
                        variant="outlined"
                        type="submit"
                        size="large"
                        disabled={loading}
                        style={{backgroundColor: "#021332",width: '350px', color: 'white', borderColor: '#021332', marginTop: 25}}
                    >
                        {loading ? <CircularProgress size={24} style={{color: 'white'}} /> : 'Change Password'}
                    </Button>
                </form>
            </div>
        </div>
    )
}

export default ChangePassword;
